/**
 * Current-user context (PHASE1 §7.1). `AuthGate` resolves the authenticated
 * user once and hands it to `UserProvider`; every component below reads it via
 * `useCurrentUser` without re-fetching `/api/auth/me`.
 */
import { createContext, type ReactNode } from 'react';
import type { CurrentUser } from '../components/AuthGate.tsx';

export type { CurrentUser };

export const UserContext = createContext<CurrentUser | null>(null);

export function UserProvider({
  user,
  children,
}: {
  user: CurrentUser;
  children: ReactNode;
}) {
  return <UserContext value={user}>{children}</UserContext>;
}
